module.exports = __webpack_public_path__ + "img/surveyNo.93aa7c5a.svg";